import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Typography, Box, UserAvatar } from 'src/components';
import { useAuth, isOnline } from 'src/utils';
import { keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
`;

const MobileFooter = React.forwardRef(({ navItems, userHasUnreadChats }, ref) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isProfileActive = location.pathname === '/profile';

  const userAvatar = (
    <UserAvatar
      user={user}
      size={user !== null ? 35 : 25}
      isMobile={true}
      isActiveTab={isProfileActive}
      showOfflineBadge={true}
      sx={{
        border: '2px solid',
        borderColor: isProfileActive ? 'primary.main' : 'transparent',
        transition: 'border 0.2s ease-in-out'
      }}
      retryImage={true}
    />
  );

  const allNavItems = [
    ...navItems,
    {
      label: user !== null ? '' : 'Profile',
      path: '/profile',
      icon: userAvatar,
      filledIcon: userAvatar
    },
  ];

  return (
    <footer
      ref={ref}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#ffffff',
        paddingBottom: 'var(--safe-area-bottom)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1000,
        boxSizing: 'border-box'
      }}
    >
      <nav
        style={{
          height: '55px',
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
          alignItems: 'center'
        }}
      >
        {allNavItems.map((item) => {
          let isActive = location.pathname.includes(item.path);
          if (location.pathname === '/' && user) {
            isActive = item.path === '/map';  
          }

          const isChatItem = item.path.includes('chat');
          if (isChatItem) {
              isActive = location.pathname.includes("chat");
          }

          return (
            <Button
              key={item.label}
              aria-label={item.label}
              onClick={() => navigate(item.path)}
              disableRipple
              disableTouchRipple
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                minWidth: '60px',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                color: isActive ? 'primary.main' : '#aaa',
                height: '55px',
                boxSizing: 'border-box',
                padding: '0 4px'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: isActive ? `${bounce} 0.4s ease` : 'none',
                  overflow: 'hidden',
                  height: item.label === '' ? '100%' : '30px', 
                  width: item.label === '' ? '100%' : '30px'
                }}
              >
                {isActive ? item.filledIcon : item.icon}
              </Box>

              <Box sx={{display: 'inline-flex', alignItems: 'center', position: 'relative'}}>

                <Typography
                  sx={{
                    fontWeight: isActive ? 700 : 500,
                    textAlign: 'center',
                    fontSize: '9px',
                    lineHeight: '12px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    pr: isChatItem && userHasUnreadChats ? 0.5 : 0,
                  }}
                >
                  {item.label}
                </Typography>

                {isChatItem && userHasUnreadChats && (
                  <Box
                    sx={{ 
                      position: 'absolute',
                      top: 0,
                      right: -4,
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      bgcolor: 'secondary.main',
                    }}
                  />
                )}

              </Box>

            </Button>
          );
        })}
      </nav>
    </footer>
  );
});

export default MobileFooter;
